module.exports = __webpack_public_path__ + "static/media/main_background.703c801e.jpg";